// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

// Define a service using a base URL and expected endpoints
export const optionMasterAPI = createApi({
  reducerPath: 'optionMasterAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getOptionsList: builder.query<any, optionMasterArgTypes>({
      query: ({ applicationCode, optionMasterName }) => ({
        url: `/admin/optionmasters/application/${applicationCode}/name/${optionMasterName}`,
        method: 'GET',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetOptionsListQuery } = optionMasterAPI;
